import type { DistanceUnit } from '@wineryxplorer/shared';
import { ChangePasswordSection } from './ChangePasswordSection';
import { DisplaySection } from './DisplaySection';
import { LinkedProvidersSection } from './LinkedProvidersSection';
import { PhoneSection } from './PhoneSection';
import { ENABLE_ACCOUNT_LINKING } from '../../config/featureFlags';

interface SettingsTabProps {
  hasPassword: boolean;
  phoneNumber: string | null | undefined;
  phoneVerified: boolean;
  /** Undefined when the user has never chosen a unit. */
  distanceUnit: DistanceUnit | undefined;
}

export const SettingsTab = ({
  hasPassword,
  phoneNumber,
  phoneVerified,
  distanceUnit,
}: SettingsTabProps) => {
  return (
    <div>
      <DisplaySection distanceUnit={distanceUnit} />
      <ChangePasswordSection hasPassword={hasPassword} />
      {ENABLE_ACCOUNT_LINKING && <LinkedProvidersSection />}
      <PhoneSection currentPhone={phoneNumber} phoneVerified={phoneVerified} />
    </div>
  );
};
